var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,_vm._b({tag:"component",staticClass:"cta-button button is-primary nacelle",on:{"click":(event) => _vm.$emit('clicked', event)}},'component',_vm.linkProps(),false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }